export default __webpack_public_path__ + "static/media/ic_recycle-colored.9ab777b3.svg";